export default {
  LinkSection: {
    labelText1:
      'Please add the link of job description (Indeed/Google/Linkedin)',
    placeholderText: 'Link',
  },
  ManualPasteSecion: {
    labelText2:
      'Please copy and paste the Job description into the following text box *',
    placeholderTexts: {
      JOB_TITLE: 'Job Title',
      JOB_LOCATION: 'Job Location',
      JOB_DESCRIPTION: 'Job Description',
    },
  },
  AIReviewPopup: {
    heading: 'AI review',
    subHeading: 'Select your current experience level:',
  },
  JDReviewPopup: {
    heading: 'Job Description',
    subHeading: 'Please copy/paste the job description below:',
  },
  ButtonsText: {
    SAVE: 'Save',
    CANCEL: 'Cancel',
    CLEAR: 'Clear',
    SAVING: 'Saving...',
    EVALUATING: 'Evaluating...',
    EVALUATE: 'Evaluate',
    SAVE_AND_EXIT: 'Save & Exit',
    GENERATE: 'Generate',
  },
  CategorySection: {
    labelText3:
      'Please indicate the category you belong to (choose one option below) *',
    options: [
      'High School',
      'Undergraduate',
      'Graduate',
      '1-5 yrs Exp',
      '5+ yrs Exp',
    ],
  },
};
